/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-07-06 20:10:28
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-18 11:29:30
 */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import en from "i18n/en.js";//
import am from "i18n/js/am-rET.js";// 阿姆哈拉语
import ar from "i18n/js/ar.js";// 阿拉伯语
import as from "i18n/js/as.js";// 阿萨姆语
import bn from "i18n/js/bn-rBD.js";// 孟加拉语
import ckb from "i18n/js/ckb-rIQ.js";// 中库尔德语
import es from "i18n/js/es-rUS";// 西班牙语
import fa from "i18n/js/fa";// 波斯语
import fr from "i18n/js/fr";// 法语
import gu from "i18n/js/gu-rIN";// 古吉拉特语
import ha from "i18n/js/ha";// 豪萨语
import hi from "i18n/js/hi";// 印地语
import id from "i18n/js/id";// 印度尼西亚语
import iw from "i18n/js/iw";//希伯来语
import kk from "i18n/js/kk-rKZ";// 哈萨克语
import km from "i18n/js/km-rKH";//高棉语
import kn from "i18n/js/kn-rIN";//卡纳达语
import ks from "i18n/js/ks";//克什米尔语
import lo from "i18n/js/lo-rLA";// 老挝语
import ml from "i18n/js/ml";// 马拉雅拉姆语
import mr from "i18n/js/mr-rIN";// 马拉地语
import ms from "i18n/js/ms-rMY";//马来语
import myMM from "i18n/js/my-rMM";//缅甸语
import myZG from "i18n/js/my-rZG";//缅甸语
import ne from "i18n/js/ne-rNP";//尼泊尔语
import om from "i18n/js/om-rET";//奥罗莫语
import or from "i18n/js/or";// 奥里亚语
import pa from "i18n/js/pa-rIN";// 旁遮普语
import ptBR from "i18n/js/pt-rBR";// 葡萄牙语
import ptPt from "i18n/js/pt-rPT";// 葡萄牙语
import ru from "i18n/js/ru";// 俄语
import si from "i18n/js/si-rLK";// 僧伽罗语
import so from "i18n/js/so";//索马里语
import sw from "i18n/js/sw";// 斯瓦希里语
import ta from "i18n/js/ta-rIN";// 泰米尔语
import te from "i18n/js/te-rIN";//泰卢固语
import th from "i18n/js/th-rTH";//泰语
import ti from "i18n/js/ti-rET";// 提格利尼亚语
import tl from "i18n/js/tl";//
import tr from "i18n/js/tr";//土耳其语
import uk from "i18n/js/uk-rUA";// 乌克兰语
import ur from "i18n/js/ur-rPK";//乌尔都语
import zhCN from "i18n/js/values-zh-rCN";//简体中文
import zhTW from "i18n/js/zh-rTW";//繁体中文
import vi from "i18n/js/vi-rVN";// 越南语

// 错误链接处理-----#/有参数
let hrefIndex1 = window.location.href.indexOf("?");
let hrefIndex2 = window.location.href.indexOf("#/");
if (hrefIndex1 < hrefIndex2 && hrefIndex1 > -1) {
  let href1 = window.location.href.split("?")[0];
  let href2 = window.location.href.split("?")[1].split("#/")[0];
  let href3 = window.location.href.split("#/")[1];
  if (href3.indexOf("?") > -1) {
    // 有渠道参数
    let phref = href1 + "#/" + href3 + "&" + href2;
    // console.log(phref)
    window.location.href = phref;
  } else {
    let phref = href1 + "#/" + href3 + "?" + href2;
    // console.log(phref)
    window.location.href = phref;
  }
}



// 反向语言
// 阿拉伯语  ar
// 乌尔都语 ur-rPK
// 波斯语 fa
// 哈萨克语 kk-rKZ
// 库尔德语  ckb-rIQ
// 克什米尔语 ks
const rtlList = ['ar', 'ur', 'fa', 'kk', 'ckb', 'ks',]
const coulanList = [
  'ar', 'fr', 'en', 'am', 'as', 'bn', 'ckb', 'es', 'fa', 'gu',
  'ha', 'hi', 'id', 'iw', 'kk', 'km', 'kn', 'ks', 'lo',
  'ml', 'mr', 'ms', 'myMM', 'myZG', 'ne', 'om', 'or', 'pa',
  'ptBR', 'ptPt', 'ru', 'si', 'so', 'sw', 'ta', 'te',
  'th', 'ti', 'tl', 'tr', 'uk', 'ur', 'zhCN', 'zhTW', 'vi'
]

let lang =  (navigator.languages && navigator.languages[0]) || navigator.language;
let langUse: string;

// lang='ru'

// 设置语言
if (coulanList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
  langUse = lang.split("-")[0].toLowerCase();
} else if (lang.split("-")[0].toLowerCase() === "my") {
  if (lang.toLowerCase().indexOf('zg') > -1) {
    langUse = "myZG";
  } else {
    langUse = 'myMM'
  }
} else if (lang.split("-")[0].toLowerCase() === "pt") {
  if (lang.toLowerCase().indexOf('br') > -1) {
    langUse = "ptBR";
  } else {
    langUse = 'ptPt'
  }
} else if (lang.split("-")[0].toLowerCase() === "zh") {
  if (lang.toLowerCase().indexOf('tw') > -1) {
    langUse = "zhTW";
  } else {
    langUse = 'zhCN'
  }
} else {
  langUse = "en";
}

//语言正反向
if (rtlList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
  document.body.style.direction = "rtl";
} else {
  document.body.style.direction = "ltr";
}

//url解析入参
function _parseQueryString(queryString: any) {
  if (queryString && queryString.startsWith("?")) {
    const result: any = {};
    queryString
      .slice(1)
      .split("&")
      .forEach((item: any) => {
        const keyValueList = item.split("=");
        result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
      });
    return result;
  } else {
    return {};
  }
}

intl.init({
  currentLocale: langUse,
  locales: {
    ar, fr, en, am, as, bn, ckb, es, fa, gu,
    ha, hi, id, iw, kk, km, kn, ks, lo,
    ml, mr, ms, myMM, myZG, ne, om, or, pa,
    ptBR, ptPt, ru, si, so, sw, ta, te,
    th, ti, tl, tr, uk, ur, zhCN, zhTW, vi
  },
});
// 谷歌埋点---打开所有预约页面的pageview，不区分渠道
// gtag('event', 'Reservation_PageView');
let url: any = _parseQueryString("?" + window.location.href.split("?")[1]);
if (url.source) {
  if (url.source.toLowerCase() === 'phonerepairsns') {
    gtag('event', 'Reservation_PV_SNS');
  } else if (url.source.toLowerCase() === 'phonerepairweb') {
    gtag('event', 'Reservation_PV_Web');
  } else if (url.source.toLowerCase() === 'apppost' || url.source.toLowerCase() === 'phonerepair' || url.source.toLowerCase() === 'app') {
    gtag('event', 'Reservation_PV_App');
  } else {
    gtag('event', 'Reservation_PV_' + (url.source.toLowerCase()));
  }
} else {
  gtag('event', 'Reservation_PV_H5');
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
